export * from './components/Persona/index';
